import { Component, Input, SimpleChanges } from '@angular/core';
import { CylinderTemperatureComponent } from '@components/cylinder-temperature/cylinder-temperature.component';
import { ExhaustGraphChannel } from '@models/graphs';

@Component({
    selector: 'app-turbo-charger',
    templateUrl: './turbo-charger.component.html',
    styleUrls: ['./turbo-charger.component.css'],
    standalone: false
})
export class TurboChargerComponent extends CylinderTemperatureComponent {
    @Input() temperatures: ExhaustGraphChannel[];
}
